import * as React from "react";
import type { SVGProps } from "react";
const SvgSweater = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#352F28"
      fillRule="evenodd"
      d="M10 6.167c.879 0 1.652-.454 2.098-1.14.192-.296.496-.527.85-.527h1.219c2.3 0 4.166 1.867 4.166 4.167v7.5A.836.836 0 0 1 17.5 17H15v1.667c0 .46-.373.833-.833.833H5.833A.833.833 0 0 1 5 18.667V17H2.5a.836.836 0 0 1-.833-.833v-7.5c0-2.3 1.866-4.167 4.166-4.167h1.22c.353 0 .657.231.85.527A2.5 2.5 0 0 0 10 6.167m-3.334 0h-.833a2.507 2.507 0 0 0-2.5 2.5v6.666H5V9.5c0-.458.375-.833.833-.833.459 0 .834.375.834.833v8.333h6.666V9.5c0-.458.375-.833.834-.833S15 9.042 15 9.5v5.833h1.667V8.667c0-1.375-1.125-2.5-2.5-2.5h-.833A4.16 4.16 0 0 1 10 7.833a4.16 4.16 0 0 1-3.334-1.666"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSweater;
